/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Pit1_TInputs */

const en_sorter_pit1_t = /** @type {(inputs: Sorter_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeric keys ignore the sort direction entirely`)
};

const ko_sorter_pit1_t = /** @type {(inputs: Sorter_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숫자 키는 정렬 방향을 완전히 무시합니다`)
};

const ja_sorter_pit1_t = /** @type {(inputs: Sorter_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値キーは並べ替えの方向を完全に無視します`)
};

/**
* | output |
* | --- |
* | "Numeric keys ignore the sort direction entirely" |
*
* @param {Sorter_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_pit1_t = /** @type {((inputs?: Sorter_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_pit1_t(inputs)
	if (locale === "ko") return ko_sorter_pit1_t(inputs)
	return ja_sorter_pit1_t(inputs)
});